import { ApolloError } from "@apollo/client";
import { Alert, Button, Stack } from "@mui/material";
import { useTranslation } from "react-i18next";

import { GqlFieldworkerPaymentScope } from "~/__generated__";
import GaiaPageGridComponent from "~/modules/app/components/GaiaPageGridComponent";
import GaiaPageLayoutColumn from "~/modules/app/components/GaiaPageLayoutColumn";
import ErrorScreen from "~/modules/app/screens/ErrorScreen";

import useFieldworkerPaymentGetAll from "../api/useFiedworkerPaymentGetAll";
import useFieldworkerPaymentCreate from "../api/useFieldworkerPaymentCreate";
import PaidPayments from "../components/PaidPayment";

export default function PaymentListScreen() {
    const { t } = useTranslation("payments");

    const paymentQuery = useFieldworkerPaymentGetAll();
    const createPaymentAsync = useFieldworkerPaymentCreate();

    const handleCreatePayment = async (scope: GqlFieldworkerPaymentScope) => {
        await createPaymentAsync.createPayment(scope);
    };

    if (paymentQuery.error !== undefined) {
        return <ErrorScreen error={paymentQuery.error} />;
    }

    const payments = paymentQuery.data ?? [];

    return (
        <GaiaPageLayoutColumn>
            <GaiaPageGridComponent title={t("paymentListScreen.title")}>
                <Stack alignItems="flex-start" spacing={1}>
                    <Button
                        loading={createPaymentAsync.loading}
                        onClick={() => handleCreatePayment(GqlFieldworkerPaymentScope.External)}
                    >
                        {t("paymentRecordAllUser.btnMakeTentooPayment")}
                    </Button>
                    <Button
                        loading={createPaymentAsync.loading}
                        onClick={() => handleCreatePayment(GqlFieldworkerPaymentScope.Internal)}
                    >
                        {t("paymentRecordAllUser.btnMakeOtherPayment")}
                    </Button>
                </Stack>

                {createPaymentAsync.error !== undefined && (
                    <Alert severity="error" sx={{ my: 1 }}>
                        {extractServerError(createPaymentAsync.error)}
                    </Alert>
                )}

                {paymentQuery.error !== undefined ? (
                    <ErrorScreen error={paymentQuery.error} />
                ) : payments.length > 0 ? (
                    <PaidPayments data={payments} loading={paymentQuery.loading || createPaymentAsync.loading} />
                ) : (
                    //TODO: change the message looks
                    <div style={{ padding: "1rem", color: "#666" }}>
                        {t("paymentListScreen.noData", "No Payment has been made")}
                    </div>
                )}
            </GaiaPageGridComponent>
        </GaiaPageLayoutColumn>
    );
}

function extractServerError(error: Error) {
    if (!(error instanceof ApolloError)) {
        return "Something went wrong, please try again later.";
    }

    return (
        // @ts-expect-error property `result` is untyped
        error.cause?.result?.errors?.[0]?.message ?? "Something went wrong, please try again later."
    );
}
